import { Component, Vue, Watch } from 'vue-property-decorator';
import DateDropdown from '@/components/DateDropdown.vue';
import SelectDropdown from '@/components/SelectDropdown.vue';
// import MultistageDropdown from '@/components/MultistageDropdown.vue';
import moment from 'moment';
import config from '../../../api/params.config';
import cookie from '@/assets/js/cookie/cookie';
import check from '@/assets/js/check/check';
import storage from 'good-storage';

@Component({
    components: {
        DateDropdown,
        SelectDropdown,
        // MultistageDropdown,
    },
})
export default class Entry extends Vue {
    private $api: any;
    private isShow: boolean = false; // 基本信息页
    private degreeShow: boolean = false; // 学历和家庭信息页
    private bankCardShow: boolean = false; // 银行卡信息页
    private userName: string = ''; // 登录人姓名
    private userId: string = ''; // 登录人姓名id
    private userCode: string = ''; // 登录人姓名code
    private userDepartId: string = ''; // 登录人部门id
    private user: any = {
        baseId: '',
        resumeId: '',
        Name: '',
        UserName: '',
        Sex: 0,
        NativePlace: '',
        Address: '',
        BirthTime: '',
        IdentificationType: '',
        IdentificationTypeId: '',
        IdentificationCard: '', // 证件号码
        PhoneNumber: '',
        Email: '',
        EnterpriseMail: '',
        StaffProperty: '', // 员工属性id
        ResearchSysId: '', // 专业线id
        Probation: 0, // 试用期
        EntryTime: '',
        PositiveTime: '',
        BasePlace: '',
        BasePlaceId: '',
        WorkPlace: '',
        WorkPlaceId: '',
        OfficePlace: '',    // 办公职场
        OfficePlaceId: '', // 办公职场id
        IsUndo: 2,
     }; // 基本信息
    private degree: any = {
        SchoolName: '',
        SpecialtyName: '',
        EducationTypeId: '', // 学历Id
        DegreeTypeId: '', // 学位名称Id
        BeginAt: '', // 开始时间
        EndAt: '', // 结束时间
    }; // 学历信息
    private dependent: any = {
        Name: '',
        RelationshipId: '', // 与本人关系
        IsEmergencyContact: true, // 是否紧急联系人
        PhoneNumber: '',
    }; // 家庭信息
    private bankCard: any = {
        AccountType: '借记卡',
        AccountTypeId: '8da639f9-ab31-44a7-b123-152594b2989a',
        MoneyCode: '人民币',
        MoneyCodeId: '9075d661-30e2-459b-ac90-ae6305910dd7',
        Nation: '中国',
        UserBaseInfoId: '',
        UserName: '',
    }; // 银行卡信息

    private sexData: any = []; // 性别Array
    private staffData: any = []; // 员工属性Array
    private officePlaceList: any = []; // 办公职场Array
    private projectData: any = []; // 专业线Array
    private cityData: any = []; // 城市Array
    private educationData: any = []; // 学历Array
    private degreeData: any = []; // 学位Array
    private relationData: any = []; // 关系Array
    private booleanData: any = []; // booleanArray
    private projectShow: boolean = false; // 是否展示专业线弹窗
    private basePlaceShow: boolean = false; // 是否展示base地弹窗
    private workPlaceShow: boolean = false; // 是否展示工作地弹窗
    private radio: any = ''; // 单选框绑定
    private researchGroup: boolean = true; // 是否需要填写专业线
    private isAddCard: boolean = true; // 保存银行卡信息时是否是新建信息
    private infoList: any = {}; // 保存参数
    private isDisabledbase: boolean = false; // 防止重复提交
    private isDisableddegree: boolean = false;
    private isDisabledbank: boolean = false;
    public mounted() {
        this.init();
    }
    // 初始化
    private async init() {
        this.$toast.loading({
            duration: 0,       // 持续展示toast
            forbidClick: true, // 禁用背景点击
            loadingType: 'spinner',
            message: '正在加载...',
        });
        // 获取基础信息
        this.sexData = [
            {id: 0, text: '男'},
            {id: 1, text: '女'},
        ];
        // 获取员工属性信息
        const staffResult = await this.$api.httpGet('basic/DictionaryInfo/TypeList', {id: config.StaffAttrTypeId});
        if (staffResult.Success) {
            if (staffResult.Data) {
                for (const x of staffResult.Data) {
                    this.staffData.push({id: x.Id, text: x.Value});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: staffResult.AllMessages,
            });
        }
        // 获取办公职场信息
        // config里的id要改
        const officePlaceResult = await this.$api.httpGet('Membership/UserBaseInfo/GetOfficePlaceList');
        if (officePlaceResult.Success) {
            if (officePlaceResult.Data) {
                for (const x of officePlaceResult.Data) {
                    this.officePlaceList.push({id: x.Id, text: x.OfficeName});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: '获取数据失败，请检查网络连接',
            });
        }

        // 获取学历信息
        const educationResult = await this.$api.httpGet('basic/DictionaryInfo/TypeList', {id: config.HighestEducationTypeId});
        if (educationResult.Success) {
            if (educationResult.Data) {
                for (const x of educationResult.Data) {
                    this.educationData.push({id: x.Id, text: x.Value});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: educationResult.AllMessages,
            });
        }
        // 获取学位信息
        const degreeResult = await this.$api.httpGet('basic/DictionaryInfo/TypeList', {id: config.DegreeTypeId});
        if (degreeResult.Success) {
            if (degreeResult.Data) {
                for (const x of degreeResult.Data) {
                    this.degreeData.push({id: x.Id, text: x.Value});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: degreeResult.AllMessages,
            });
        }
        // 获取家庭信息
        const relationResult = await this.$api.httpGet('basic/DictionaryInfo/TypeList', {id: config.RelationshipId});
        if (relationResult.Success) {
            if (relationResult.Data) {
                for (const x of relationResult.Data) {
                    this.relationData.push({id: x.Id, text: x.Value});
                }
            } else {
                this.$dialog.alert({
                    title: '警告',
                    message: '未查询到相关信息',
                });
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: relationResult.AllMessages,
            });
        }
        this.booleanData = [
            {id: 1, text: '是'},
            {id: 0, text: '否'},
        ];
        // 编辑获取登录人信息
        this.userCode = cookie.get('CURLOGINNAME');
        const modal = {
            codeStr: this.userCode,
            isEncrypt: false,
        };
        const userData = await this.$api.httpGet('BaiDuApi/BaiDuFace/GetUserInfoByCode', modal);
        if (userData.Success) {
            this.userName = userData.Data.UserName;
            this.userId = userData.Data.Id;
            this.userDepartId = userData.Data.DepartId;
        } else {
            this.$dialog.alert({
                title: '错误',
                message: userData.AllMessages,
            });
        }
        // 获取研发部门
        const departData = await this.$api.httpGet('Membership/UserBaseInfo/GetDepartListById');
        if (departData.Success) {
            if (departData.Data.indexOf(this.userDepartId) === -1) {
                this.researchGroup = false;
            } else {
                // 当前登录人在需要维护专业线的研发部门中，则需要填写专业线字段
                this.researchGroup = true;
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: departData.AllMessages,
            });
        }
        // 编辑二次编辑信息
        const params = {
            code: this.userCode,
        };
        const editData = await this.$api.httpGet('WeChatInterface/WeChatInterface/GetEntryEditInfoByCode', params);
        if (editData.Success) {
            // 员工信息
            if (editData.Data.UserInfo === null) {
                this.user = {};
                this.user.sexInfo = {};
                this.user.StaffAttr = {};
                this.user.OfficePlaceData = {};
                this.isShow = true;
                this.degreeShow = false;
                this.bankCardShow = false;
            } else {
                this.user = editData.Data.UserInfo;
                this.user.baseId = editData.Data.UserInfo.Id;
                this.user.resumeId = editData.Data.UserInfo.ResumeInfoId;
                this.user.sexInfo = {}; // 性别
                if (this.user.Sex !== null && this.user.Sex === 0) {
                    this.user.sexInfo.value = '男';
                    this.user.sexInfo.id = 0;
                } else if (this.user.Sex !== null && this.user.Sex === 1) {
                    this.user.sexInfo.value = '女';
                    this.user.sexInfo.id = 1;
                } else {
                    this.user.sexInfo.value = '';
                    this.user.sexInfo.id = null;
                }
                this.user.StaffAttr = {}; // 员工属性
                for (const x of this.staffData) {
                    if (this.user.StaffProperty !== null && this.user.StaffProperty === x.id) {
                        this.user.StaffAttr.id = x.id;
                        this.user.StaffAttr.value = x.text;
                    }
                }
                this.user.OfficePlaceData = {}; // 办公职场
                for (const x of this.officePlaceList) {
                    if (this.user.OfficePlaceId !== null && this.user.OfficePlaceId === x.id) {
                        this.user.OfficePlaceData.id = x.id;
                        this.user.OfficePlaceData.value = x.text;
                    }
                }
                this.isShow = true;
                this.degreeShow = false;
                this.bankCardShow = false;
            }
            // 学历信息
            if (editData.Data.DegreeList.length > 0) {
                this.degree = editData.Data.DegreeList[0];
                this.degree.EducationType = {}; // 学历
                if (this.degree.EducationTypeId !== null && this.degree.EducationTypeId !== undefined) {
                    this.degree.EducationType.value = this.degree.EducationTypeText;
                    this.degree.EducationType.id = this.degree.EducationTypeId;
                }
                this.degree.DegreeType = {}; // 学位
                if (this.degree.DegreeTypeId !== null && this.degree.DegreeTypeId !== undefined) {
                    this.degree.DegreeType.value = this.degree.DegreeTypeText;
                    this.degree.DegreeType.id = this.degree.DegreeTypeId;
                }
                this.isShow = false;
                this.degreeShow = true;
                this.bankCardShow = false;
            } else {
                this.degree = {};
                this.degree.EducationType = {};
                this.degree.DegreeType = {};
            }
             // 家庭信息
            if (editData.Data.DependentList.length > 0) {
                this.dependent = editData.Data.DependentList[0];
                this.dependent.Relationship = {}; // 与本人关系
                if (this.dependent.RelationshipId !== null && this.dependent.RelationshipId !== undefined) {
                    this.dependent.Relationship.value = this.dependent.RelationshipText;
                    this.dependent.Relationship.id = this.dependent.RelationshipId;
                }
                this.dependent.IsEmergencyContactInfo = {}; // 是否紧急联系人
                if (this.dependent.IsEmergencyContact !== null && this.dependent.IsEmergencyContact === true) {
                    this.dependent.IsEmergencyContactInfo.value = '是';
                    this.dependent.IsEmergencyContactInfo.id = 1;
                } else if (this.dependent.IsEmergencyContact !== null && this.dependent.IsEmergencyContact === false) {
                    this.dependent.IsEmergencyContactInfo.value = '否';
                    this.dependent.IsEmergencyContactInfo.id = 0;
                } else {
                    this.dependent.IsEmergencyContactInfo.value = '';
                    this.dependent.IsEmergencyContactInfo.id = null;
                }
                this.isShow = false;
                this.degreeShow = true;
                this.bankCardShow = false;
            } else {
                this.dependent = {};
                this.dependent.Relationship = {};
                this.dependent.IsEmergencyContactInfo = {};
            }
            // 银行卡信息
            if (editData.Data.BankCardInfo === null) {
                this.bankCard = {};
                this.bankCard.IsPayCardInfo = {};
                this.isAddCard = true;
            } else {
                this.bankCard = editData.Data.BankCardInfo;
                this.bankCard.IsPayCardInfo = {}; // 是否工资卡
                if (this.bankCard.IsPayCard !== null && this.bankCard.IsPayCard === true) {
                    this.bankCard.IsPayCardInfo.value = '是';
                    this.bankCard.IsPayCardInfo.id = 1;
                } else if (this.bankCard.IsPayCard !== null && this.bankCard.IsPayCard === false) {
                    this.bankCard.IsPayCardInfo.value = '否';
                    this.bankCard.IsPayCardInfo.id = 0;
                } else {
                    this.bankCard.IsPayCardInfo.value = '';
                    this.bankCard.IsPayCardInfo.id = null;
                }
                this.isAddCard = false;
                this.isShow = false;
                this.degreeShow = false;
                this.bankCardShow = true;
            }
            if (editData.Data.UserInfo !== null && editData.Data.UserInfo.IsUndo !== 2) {
                this.isShow = false;
                this.degreeShow = false;
                this.bankCardShow = false;
                this.$dialog.alert({
                    title: '提示',
                    message: '您已经完成入职编辑，如需修改信息，请联系人事专员。',
                });
            }
            this.$toast.clear();
        } else {
            this.isShow = true;
            this.$toast.clear();
            this.$dialog.alert({
                title: '错误',
                message: editData.AllMessages,
            });
        }
        this.user.IdentificationType = '身份证';
        this.user.IdentificationTypeId = 'a4b16a67-494a-4484-bce2-50715af0a4c4';
        this.bankCard.AccountType = '借记卡';
        this.bankCard.AccountTypeId = '8da639f9-ab31-44a7-b123-152594b2989a';
        this.bankCard.MoneyCode = '人民币';
        this.bankCard.MoneyCodeId = '9075d661-30e2-459b-ac90-ae6305910dd7';
        this.bankCard.Nation = '中国';
        this.bankCard.UserBaseInfoId = this.userId;
        this.bankCard.UserName = this.userName;
    }
    // 打开级联选择popup
    private async multiShow(value: any) {
        if (value === 1) {
            // 选择专业线
            this.projectShow = true;
            // 获取专业线信息
            const projectResult =  await this.$api.httpGet('Membership/UserBaseInfo/GetSDepartListById');
            if (projectResult.Success) {
                if (projectResult.Data) {
                    this.projectData = projectResult.Data;
                }
            }
        } else if (value === 2 || value === 3) {
            const provinceObj = storage.get('provinceList', this.cityData);
            if (provinceObj.length > 0) {
                // 取出缓存中的省份信息，不再请求接口
                this.cityData = provinceObj;
            } else {
                this.cityData = [];
                // 获取城市（省份）信息
                this.$api.DataCenterGet('basic/District/GetTopDistrict', null, (result: any) => {
                    for (const x of result.data.Data) {
                        this.cityData.push({id: x.Id, text: x.Name, parentId: x.ParentId});
                    }
                    if (this.cityData.length > 0) {
                        storage.set('provinceList', this.cityData);
                    }
                }, (error: any) => {
                    console.log(error);
                });
            }
            if (value === 2) {
                this.basePlaceShow = true;
            } else if (value === 3) {
                this.workPlaceShow = true;
            }
        }
    }
    // 级联选择popup选择数据
    private async multiSure(value: any, item: any) {
        if (value === 1) {
            this.radio = item.id;
            if (item.children === true) {
                // 1、当前所选还有子级：刷新当前cell，展示子级列表
                const model = {
                    id: item.id,
                    BelongType: 2,
                    ByLevel: true,
                };
                const projectResult = await this.$api.httpGet('basic/Departmentlevel/ListChildDeparts', model);
                if (projectResult.Success) {
                    if (projectResult.Data) {
                        this.projectData = projectResult.Data;
                    }
                }
            } else {
                // 2、当前所选没有子级，已是最底层：选中当前数据，关闭popup
                this.user.ResearchSysName =  item.text;
                this.user.ResearchSysId = item.id;
                this.projectShow = false;
            }
        } else if (value === 2 || value === 3) {
            this.radio = item.id;
            this.cityData = [];
            const cityObj = storage.get('cityList', this.cityData);
            const hadObj = cityObj.some((val: any) => {
                return val.parentId === item.id;
            });
            if (cityObj.length > 0 && hadObj === true) {
                // 取出缓存中的城市信息，不再请求接口
                for (const x of cityObj) {
                    if (x.parentId === item.id) {
                        this.cityData.push(x);
                    }
                }
            } else {
                const params = {
                    ParentId: item.id,
                };
                // 获取城市（城市）信息
                this.$api.DataCenterGet('basic/District/GetDistrictByParentId', params, (result: any) => {
                    let isDistrict; // 使用城市code后两位判断当前城市是否是区县级，后续需注意code是否发生变化
                    for (const x of result.data.Data) {                        
                        const codeSub = x.Code.substring(4, 6); // 截取code后两位
                        if (codeSub === '00') {
                            isDistrict = false;
                            this.cityData.push({id: x.Id, text: x.Name, parentId: x.ParentId});
                        } else {
                            isDistrict = true;
                        }
                    }
                    if (this.cityData.length > 0) {
                        storage.set('cityList', this.cityData);
                    }
                    if (result.data.Data.length === 0 || isDistrict) {
                        // 2、当前所选没有子级，已是最底层：选中当前数据，关闭popup
                        if (value === 2) {
                            this.user.BasePlace =  item.text;
                            this.user.BasePlaceId = item.id;
                            this.basePlaceShow = false;
                        } else if (value === 3) {
                            this.user.WorkPlace =  item.text;
                            this.user.WorkPlaceId = item.id;
                            this.workPlaceShow = false;
                        }
                    }
                }, (error: any) => {
                    console.log(error);
                });
            }
        }
    }
    // 通过试用期和入职日期计算转正日期
    private async probationChange(value: any) {
        if (this.user.EntryTime !== '' && this.user.EntryTime !== null && this.user.EntryTime !== undefined && value !== '' && value !== undefined) {
            this.user.PositiveTime = moment(this.user.EntryTime).add(value, 'months').format('YYYY-MM-DD');
        } else {
            this.user.PositiveTime = '';
        }
    }
    @Watch('user.EntryTime') private Probation() {
        if (check.checkNull(this.user.Probation) && check.checkNull(this.user.EntryTime)) {
            this.user.PositiveTime = moment(this.user.EntryTime).add(this.user.Probation, 'months').format('YYYY-MM-DD');
        } else {
            this.user.PositiveTime = '';
        }
    }
    // 保存并下一步
    private async next(type: any) {
        if (type === 1) {
            // 保存基本信息
            const baseData = await this.save(1);
            if (baseData) {
                this.isDisabledbase = true;
                this.isShow = false;
                this.degreeShow = true;
            }
        } else if (type === 2) {
            // 保存学历和家庭信息
            const degreeData = await this.save(2);
            if (degreeData) {
                this.isDisableddegree = true;
                this.degreeShow = false;
                this.bankCardShow = true;
            }
        }
    }
    // 返回上一页
    private async goback(type: any) {
        if (type === 1) {
            // 返回基本信息页
            this.isDisabledbase = false;
            this.degreeShow = false;
            this.isShow = true;
        } else if (type === 2) {
            // 返回学历和家庭信息页
            this.isDisableddegree = false;
            this.bankCardShow = false;
            this.degreeShow = true;
        }
    }
    // 仅保存
    private async save(type: any) {
        if (type === 1) {
            // 验证基本信息
            if (!check.checkNull(this.user.UserName)) {
                this.$notify('请填写姓名');
                return false;
            } else if (!check.checkNull(this.user.sexInfo.value)) {
                this.$notify('请选择性别');
                return false;
            } else if (!check.checkNull(this.user.NativePlace)) {
                this.$notify('请填写籍贯');
                return false;
            } else if (!check.checkNull(this.user.Address)) {
                this.$notify('请填写详细地址');
                return false;
            } else if (!check.checkNull(this.user.BirthTime)) {
                this.$notify('请选择出生日期');
                return false;
            } else if (!check.checkNull(this.user.IdentificationCard) || !check.checkIDCard(this.user.IdentificationCard, this.user.BirthTime)) {
                this.$notify('请填写正确的证件号码');
                return false;
            } else if (!check.checkNull(this.user.PhoneNumber) || !check.checkPhone(this.user.PhoneNumber)) {
                this.$notify('请填写正确的手机号码');
                return false;
            } else if (!check.checkNull(this.user.Email) || !check.checkEmail(this.user.Email)) {
                this.$notify('请填写正确的电子邮箱');
                return false;
            } else if (!check.checkNull(this.user.EnterpriseMail) || !check.checkEmail(this.user.EnterpriseMail)) {
                this.$notify('请填写正确的企业邮箱');
                return false;
            } else if (!check.checkNull(this.user.StaffAttr.value)) {
                this.$notify('请填写员工属性');
                return false;
            } else if (!check.checkNull(this.user.ResearchSysName) && this.researchGroup === true) {
                this.$notify('研发人员请选择专业线');
                return false;
            } else if (!check.checkNull(this.user.Probation)) {
                this.$notify('请填写试用期（月）');
                return false;
            } else if (!check.checkNull(this.user.EntryTime)) {
                this.$notify('请选择入职日期');
                return false;
            } else if (!check.checkNull(this.user.PositiveTime)) {
                this.$notify('请选择转正日期');
                return false;
            } else if (!check.checkNull(this.user.BasePlace)) {
                this.$notify('请选择base地');
                return false;
            } else if (!check.checkNull(this.user.WorkPlace)) {
                this.$notify('请选择工作地');
                return false;
            } else if (!check.checkNull(this.user.OfficePlaceData.value)) {
                this.$notify('请填写办公职场');
                return false;
            } else {
                // 保存基本信息
                const saveData = await this.saveInfo(type);
                if (saveData) {
                    return true;
                }
            }
        } else if (type === 2) {
            // 验证学历和家庭信息
            if (!check.checkNull(this.degree.SchoolName)) {
                this.$notify('请填写学校名称');
                return false;
            } else if (!check.checkNull(this.degree.SpecialtyName)) {
                this.$notify('请填写专业名称');
                return false;
            } else if (!check.checkNull(this.degree.EducationType.value)) {
                this.$notify('请选择学历');
                return false;
            } else if (!check.checkNull(this.degree.DegreeType.value)) {
                this.$notify('请选择学位名称');
                return false;
            } else if (!check.checkNull(this.degree.BeginAt)) {
                this.$notify('请选择开始日期');
                return false;
            } else if (!check.checkNull(this.degree.EndAt)) {
                this.$notify('请选择毕业时间');
                return false;
            } else if (!check.checkNull(this.dependent.Name)) {
                this.$notify('请填写家属姓名');
                return false;
            } else if (!check.checkNull(this.dependent.Relationship.value)) {
                this.$notify('请选择与本人关系');
                return false;
            } else if (!check.checkNull(this.dependent.IsEmergencyContactInfo.value)) {
                this.$notify('请选择是否紧急联系人');
                return false;
            } else if (!check.checkNull(this.dependent.PhoneNumber)) {
                this.$notify('请填写联系电话');
                return false;
            } else if (!check.checkPhone(this.dependent.PhoneNumber)) {
                this.$notify('请填写正确的联系电话');
                return false;
            } else {
                // 保存学历和家庭信息
                const saveData = await this.saveInfo(type);
                if (saveData) {
                    return true;
                }
            }
        } else if (type === 3) {
            // 验证银行卡信息
            if (!check.checkNull(this.bankCard.BankCardOwner)) {
                this.$notify('请填写账户名称');
                return false;
            } else if (!check.checkNull(this.bankCard.BankCardNum)) {
                this.$notify('请填写账号');
                return false;
            } else if (!check.checkNull(this.bankCard.OpeningBank)) {
                this.$notify('请填写开户行');
                return false;
            } else if (!(check.checkNull(this.bankCard.IsPayCardInfo.value) || check.checkNull(this.bankCard.IsPayCardInfo))) {
                this.$notify('请选择是否是工资卡');
                return false;
            } else {
                // 保存银行卡信息
                if (this.bankCard.IsPayCardInfo.value === undefined) {
                    if (this.bankCard.IsPayCardInfo === '是') {
                        this.bankCard.IsPayCard = 1;
                    } else {
                        this.bankCard.IsPayCard = 0;
                    }
                } else {
                    if (this.bankCard.IsPayCardInfo.value === '是') {
                        this.bankCard.IsPayCard = 1;
                    } else {
                        this.bankCard.IsPayCard = 0;
                    }
                }
                if (this.isAddCard === true) {
                    const infoResult = await this.$api.httpPost('Membership/BankCard/Add', this.bankCard);
                    if (infoResult.Success) {
                        // 修改IsUndo更新入职编辑信息，标记为已进行入职编辑
                        const saveData = await this.saveInfo(type);
                        if (saveData) {
                            return true;
                        }
                    } else {
                        this.$dialog.alert({
                            title: '错误',
                            message: infoResult.AllMessages,
                        });
                    }
                } else {
                    const infoResult = await this.$api.httpPost('Membership/BankCard/Update', this.bankCard);
                    if (infoResult.Success) {
                        // 修改IsUndo更新入职编辑信息，标记为已进行入职编辑
                        const saveData = await this.saveInfo(type);
                        if (saveData) {
                            return true;
                        }
                    } else {
                        this.$dialog.alert({
                            title: '错误',
                            message: infoResult.AllMessages,
                        });
                    }
                }
            }
        }
    }
    // 保存信息
    private async saveInfo(type: any) {
        if (this.degree !== null && this.degree !== undefined && this.degree.DegreeType !== undefined && this.degree.EducationType !== undefined) {
            this.degree.DegreeTypeText = this.degree.DegreeType.value;
            this.degree.DegreeTypeId = this.degree.DegreeType.id;
            this.degree.EducationTypeText = this.degree.EducationType.value;
            this.degree.EducationTypeId = this.degree.EducationType.id;
        }
        if (this.dependent !== null && this.dependent !== undefined && this.dependent.Relationship !== undefined && this.dependent.IsEmergencyContactInfo !== undefined) {
            this.dependent.RelationshipText = this.dependent.Relationship.value;
            this.dependent.RelationshipId = this.dependent.Relationship.id;
            this.dependent.IsEmergencyContactText = this.dependent.IsEmergencyContactInfo.value;
            if (this.dependent.IsEmergencyContactInfo.id === 1) {
                this.dependent.IsEmergencyContact = true;
            } else {
                this.dependent.IsEmergencyContact = false;
            }
        }
        const degreeArray = [this.degree];
        const dependentArray = [this.dependent];
        this.infoList = {
            IsEntry: true,
            step: type,
            userBaseInfo: this.user,
            resumeInfo: this.user,
            degree: degreeArray,
            dependent: dependentArray,
            resumeInfoId: this.user.resumeId,
            userBaseInfoId: this.user.baseId,
        };
        if (type === 3) {
            this.infoList.userBaseInfo.IsUndo = 1;
        } else {
            this.infoList.userBaseInfo.IsUndo = 2;
        }
        this.infoList.userBaseInfo.StaffProperty = this.user.StaffAttr.id;
        this.infoList.userBaseInfo.OfficePlaceId = this.user.OfficePlaceData.id;
        this.infoList.userBaseInfo.OfficePlace = this.user.OfficePlaceData.value;
        this.infoList.resumeInfo.Name = this.user.UserName;
        this.infoList.resumeInfo.Sex = this.user.sexInfo.id;
        if (type === 3 && this.user.ResearchSysId !== '' && this.user.ResearchSysId !== null && this.researchGroup === false) {
            this.user.ResearchSysId = '';
            this.user.ResearchSysName = '';
            this.infoList.userBaseInfo.ResearchSysId = '';
            this.$notify({ type: 'warning', message: '专业线只能研发人员填写，已自动清空！' });
        }     
        // 保存编辑信息
        const infoResult = await this.$api.httpPost('Membership/UserBaseInfoAdd/WeChatUpdateInfos', this.infoList);
        if (infoResult.Success) {
            if (type === 1) {
                this.$toast.success('员工信息保存成功');
                return true;
            } else if (type === 2) {
                this.$toast.success('学历和家庭信息保存成功');
                return true;
            } else if (type === 3) {   
                this.$toast.success('银行卡信息保存成功');
                return true;
            }
        } else {
            this.$dialog.alert({
                title: '错误',
                message: infoResult.AllMessages,
            });
            return false;
        }
    }
    // 完成
    private async submit() {
        const bankData = await this.save(3);
        if (bankData) {
            this.isDisabledbank = true;
            // 所有信息保存成功
            this.$dialog.confirm({
                title: '提交成功',
                message: '是否需要跳转到人脸采集页面？',
              }).then(() => {
                // on confirm
                this.$router.replace({path: '/prove'});
              }).catch(() => {
                // on cancel
                // this.$router.go(-1);
              });
        }
    }
}
